import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "../components/loader";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup";

let { lambda, appname } = window.app;

const UpgradePage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { search } = state || {};

  const [user, setUser] = useState("");
  const [activeButtons, setActiveButtons] = useState({});
  const [perpage, setPerpage] = useState(10);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [image, setImg] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [subscriptionsData, setSubscriptionsData] = useState([]);
 
  const [flag, setFlag] = useState(false);
  const [firstTime, setFirstTime] = useState(false);
  const [activePlan, setActivePlan] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  let id = localStorage.getItem("userId");
  const {searchedFlag, setSearchedFlag,  clientInfo,isLoading, setIsLoading,isRefreshed, setIsRefreshed,userData,subscriberData,setSubscriberData, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if(prevRoute !== undefined && prevRoute!=route){
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);

console.log("clientInfoooooooooooooooooooooooooooooooooooooooooo",clientInfo)
    useEffect(() => {

      if (window.site === undefined) {
          setTimeout(() => {
              if (window.site && window.site.common && window.site.common.imageCloudfront) {
                  setImg(window.site.common.imageCloudfront)
              }
          }, 1000);
      }
      if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
      }
  
  
  }, [window.site]);

console.log("clientInfoooooooooooooooooooooooooooooooooooo",clientInfo)
   //  console.log('prevRoute--->',prevRoute)
   //  console.log('currentRoute--->',route)
  //  const keyForRerender = `${rowsPerPage}_${data?.length}`;
  //   const columns = [

  //       {
  //           name: 'Name',
  //           selector: row => row?.name ?? "",
  //           sortable: true,
  //       },
  //       {
  //           name: 'User Type',
  //           selector: row => row?.type ?? "",
  //           sortable: true,
  //       },
  //       {
  //           name: 'Email id',
  //           selector: row => row?.emailid ?? "",
  //           sortable: true,
  //       },
  //       {
  //           name: 'Phone Number',
  //           selector: row => row?.phone ?? "",
  //           sortable: true,
  //       },
  //       {
  //          name: 'Status',
  //          selector: row => row?.status ?? "",
  //          sortable: true,
  //      },
       

  //       {
  //           name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
  //           cell: (props) => 
  //          //   {
  //              subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
  //          <div className="d-flex">
  //          {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
  //              <a onClick={e => handleViewUser(e, props.userid)}
  //                  className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
  //                      className="mdi mdi-eye font-size-18"></i></a>}
  //          {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
  //              {props.userid === id ? <a
  //                  className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
  //                      className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)}
  //                          className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
  //                              className="mdi mdi-pencil font-size-18"></i></a>}</>}
  //      </div>
  //          //  }
  //           ,
  //           ignoreRowClick: true,
  //           allowOverflow: true,
  //           button: true,
  //       },
  //   ];

  useEffect(() => {
   
    if (clientInfo?.planid) {
      getSubscriptionsApi();
    }
    setActiveMenuId()
  }, [clientInfo?.planid]); // <-- run when planid is available
  
//   useEffect(() => {
//     if (!localStorage.getItem("token")) {
//         navigate("/signin");
//     }

// }, []);
  useEffect(() => {
        const token = localStorage.getItem("token");
      
        if (!token) {
          navigate("/signin");
          return;
        }
      
        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;
      
        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
          navigate("/signin");
        }
      }, [clientInfo, navigate]);

  const getSubscriptionsApi = async () => {
  setIsLoading(true);

  try {
    const response = await axios.get(`${lambda}/getSubscriptions?appname=${appname}`);
    const data = response?.data?.result;

    if (data && data !== "Invalid token or Expired") {
      setSubscriptionsData(data);

      // Set default active buttons for each plan
      const defaultButtons = {};
      data.forEach(plan => {
        defaultButtons[plan.planid] = ['Monthly', 'Yearly'];
      });
      setActiveButtons(defaultButtons);

      // Find selected plan based on clientInfo.planid
      //let dynamicPlanId = clientInfo.plantype === "Monthly" ? plan?.monthly_planid : plan?.yearly_planid
      let selectedPlanData;
      if(clientInfo.plantype === "Monthly"){
        selectedPlanData = data.find(plan => plan.monthly_planid === clientInfo?.planid);
        console.log("Selected Plan Data month:", selectedPlanData);
      }else{
        selectedPlanData = data.find(plan => plan.yearly_planid === clientInfo?.planid);
        console.log("Selected Plan Data year:", selectedPlanData);
      }
     

      if (selectedPlanData) {
        setSelectedPlan({
          ...selectedPlanData,
          planType: clientInfo.plantype
        });
      }
    } else {
      setShowSessionPopupup(true);
    }
  } catch (err) {
    console.error('Error fetching subscriptions:', err);
  } finally {
    setIsLoading(false);
  }
};

  

  useEffect(() => {
    if (activeButtons && clientInfo) {
      const btn = {};
      for (const key in activeButtons) {
        let keyNum = key
        btn[keyNum] = keyNum === (clientInfo?.planid) ? clientInfo?.plantype : 'Monthly';
      }
      
      setActivePlan(btn);
    }
  }, [activeButtons, clientInfo]);

 

  const handlePlanClick = (planId, type) => {
    setActivePlan(prev => ({
      ...prev,
      [planId]: type
    }));

    if (selectedPlan?.planid === planId) {
      setSelectedPlan(prevPlan => ({
        ...prevPlan,
        planType: type
      }));
    }
    setFirstTime(true);
  };


  const handleSelectPlan = (plan) => {
    const updatedSelectedPlan = {
      ...plan,
      planType: activePlan[plan.planid] || 'Monthly'
    };
    setSelectedPlan(updatedSelectedPlan);
    setFirstTime(true);
  };
console.log("FirstTimeeeeeeeeeeeeeeeeeeeee",firstTime)
  const handleUpgrade = () => {
    const formData = { ...subscriberData };
    formData.subscription = selectedPlan?.planname;
    formData.subscriptionPrice = selectedPlan?.planType === "Monthly" ? selectedPlan?.monthly : selectedPlan?.yearly;
    formData.plantype = selectedPlan?.planType;
    formData.planid = selectedPlan?.planType == "Monthly" ? selectedPlan?.monthly_planid : selectedPlan?.yearly_planid;
    localStorage.setItem("billingAddress",null)
    navigate("/payment", { state: formData });
  };
  const planRanks = {};
  subscriptionsData.forEach((plan, index) => {
    planRanks[plan.planname] = index + 1;
  });
  return (
    <>
      {showSessionPopupup && <SessionPopup />}
   
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        {isLoading?<Loader/>:
        <div className="main-content user-management" id="main-upgrade">
          <div className="page-content" id="page-upgrade">
            <div className="container-fluid" id="container-upgrade">
              <div className="row breadcrumb" id="breadcrumb-upgrade">
                <div className="col-lg-12" id="col-lg-upgrade">
                  <div className="d-flex align-items-center" id="items-upgrade">
                    <div className="flex-grow-1">
                    <h4 className="mb-2 card-title">Upgrade</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row table-data">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="subscription-plan">
                      
                        <p className="card-desc mb-4">Upgrade to get more out of subscription</p>
                        <div className="row registration">
                          {activePlan && subscriptionsData && clientInfo && subscriptionsData.filter(p => p.status === 'ACTIVE').map(plan => {
                             console.log("plan",plan)
                             console.log("activePlan[plan.planid]",activePlan[plan.planid])
                            const selectedType = activePlan[plan.planid] || 'Monthly';
                            console.log("selectedType",selectedType)
                            const dynamicPlanId = selectedType === 'Monthly' ? plan.monthly_planid : plan.yearly_planid
                            //const isCurrent = plan.planid === clientInfo.planid && selectedType === clientInfo.planType;
                            const isCurrent = ( selectedType === clientInfo.plantype && dynamicPlanId === clientInfo.planid) 
                            console.log("selectedPlan",selectedPlan)
                            let isSelected
                            if(selectedPlan?.planType === selectedType){
                              isSelected = selectedPlan?.monthly_planid === plan.monthly_planid;
                            }else{
                              isSelected = selectedPlan?.yearly_planid === plan.yearly_planid;
                            }
                             

                            console.log("isSelected",isSelected)
                            const planPrice = selectedType === 'Yearly' ? plan.yearly : plan.monthly;
                            const currentPlanRank = planRanks[clientInfo?.subscription];
const thisPlanRank = planRanks[plan.planname];
                           
                          
                            return (
                              <div key={plan.planid} className="col-md-3 plans" id={plan.planid}>
                                <div className={`basic_plan ${isSelected ? 'active_plan' : ''}`} id={`plan-${plan.planid}`}>
                                  <h6>{plan.planname}</h6>
                                  <p className="per_month">
                                    <span>${planPrice}</span> /per {selectedType.toLowerCase()}
                                  </p>
                                  <p>{plan.tagline}</p>
                                  <div className="select_billing mb-3">
                                    {activeButtons[plan.planid].map((planType,index) => (
                                      <button
                                        key={planType}
                                        type="button"
                                        id={`btn-${index}`}
                                        className={`yearly ${(activePlan[plan.planid] === planType || selectedType === planType)  ? 'active' : ''}`}
                                        onClick={() => handlePlanClick(plan.planid, planType)}
                                      >
                                        {planType} 
                                      </button>
                                    ))}
                                  </div>
                                  <hr />
                                  {plan.features.map((feature, index) => (
                                    feature.value && (
                                      <div key={`${plan.planid}-${index}`} className="points">
                                        <span className="material-symbols-outlined check-icons">chevron_right</span>
                                        <p>{feature.label ? `${feature.value} ${feature.feature}${feature.value > 1 ? 's' : ''}` : feature.value}</p>
                                      </div>
                                    )
                                  ))}
                                  <div className="Plan-select-footer">
                                    <button
                                      type="button"
                                      disabled={thisPlanRank < currentPlanRank}

                                      className={`fill-btn ${isSelected ? "" : "black_btn"}`}
                                      onClick={() => handleSelectPlan(plan)}
                                      id={`button-${plan.planid}`}
                                    >
                                      {isCurrent ? "Current Plan" : isSelected ? "Selected" : "Select"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          {firstTime && selectedPlan && (selectedPlan.planid !== clientInfo.planid || (selectedPlan.planid === clientInfo.planid && activePlan[selectedPlan.planid] !== clientInfo.plantype)) && (
                            <div className="col-md-3">
                              <div className="final-plan subscription-wrapper">
                                <div className="d-flex sub-header">
                                  <h3 className="description mt-1">Upgrade to</h3>
                                </div>
                                <h3 className="premium-heading">{selectedPlan.planname}</h3>
                                <h3 className="card-title">
                                  ${selectedPlan.planType === "Monthly" ? selectedPlan.monthly : selectedPlan.yearly}
                                  <span className="title-s"> /{selectedPlan.planType}</span>
                                </h3>
                                <div className="sub-section dashed mt-5">
                                  <div className="d-flex justify-content-between">
                                    <p className="description">Amount Payable</p>
                                    <p className="description">${selectedPlan.planType === "Monthly" ? selectedPlan.monthly : selectedPlan.yearly}</p>
                                  </div>
                                  <button className="basic-btn active w-100 mt-3" id="upgrade-now" onClick={handleUpgrade}>
                                    Upgrade Now
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <SweetAlert
            show={tableErrMsg}
            custom
            confirmBtnText="ok"
            confirmBtnBsStyle="primary"
            title={"Something went wrong. Please reload again."}
            onConfirm={() => setTableErrMsg(false)}
          />

          <Footer />
        </div>
        }
      </div> 
     
    </>
  );
};

export default UpgradePage;